import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, interval, Observable, Subscription } from 'rxjs';
import { authCheckOnline } from '../../../core/auth/auth.actions';
import { Backend, HealthCheck } from '../../../core/auth/auth.models';
import { selectBackendStateError, selectGetBackendState } from '../../../core/auth/auth.selectors';
import { LogService } from '../../../core/log/log.service';
import { navigateToPage } from '../../../core/router/routes.actions';
import { ErrorMessage } from '../../../domain/error/error-message.model';
import { CallService } from '../../../core/call-service/browser/call.service';
import { HttpClient } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe, JsonPipe } from '@angular/common';


@Component({
    selector: 'dottnet-offline',
    templateUrl: './offline.component.html',
    styleUrls: ['./offline.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, JsonPipe, TranslateModule]
})
export class OfflineComponent implements OnInit, OnDestroy {
	waitForOnline: Subscription;
	redirectWhenOnline$: Observable<Backend>;
	getParameters: Subscription;
	currentInterval: number = 0;
	returnTo: string = '';
	backendError$: Observable<ErrorMessage>;

	prevRoute: string = '';

	result$: Observable<HealthCheck> = new Observable();
	unsub: Subscription = new Subscription();


	constructor(
		private store: Store,
		private activatedRoute: ActivatedRoute,
		private logService: LogService,
		private changeDetectorRef: ChangeDetectorRef,
		private callService: CallService,
		private http: HttpClient,

	) { }

	ngOnInit() {
		// check healthcheck endpoint once for a second. Will be stopped when we are online again
		this.waitForOnline = interval(4000)
			// .pipe(take(10))
			.subscribe((current) => {
				this.logService.info('App offline. Checking if online. Try #' + current + 1);
				this.currentInterval = current + 1;
				this.changeDetectorRef.detectChanges();
				this.store.dispatch(authCheckOnline());
			});


/*		this.waitForOnline = interval(5000)
			// .pipe(take(10))
			.subscribe((current) => {
				this.currentInterval = current + 1;
				console.info('App offline. Checking if online. Try #' + this.currentInterval);
				this.changeDetectorRef.detectChanges();
				this.result$ = this.http.get<HealthCheck>('http://localhost:8800/healthcheck')
				//this.result$ = this.callService.CallHealthCheck();

				this.unsub = this.result$.subscribe({
					next: (hc: HealthCheck) => console.log('received ', hc),
					error: err => console.log('Received err', err)
				});
			});
		*/	
		// when we are back online, we can redirect to the page we came from, and stop checking online status
			this.redirectWhenOnline$ = this.store.select(selectGetBackendState);
			this.redirectWhenOnline$.subscribe((backendState) => {
				if (backendState === Backend.ONLINE) {
					this.logService.info('App is back online. Stopping checkOnline');
					if (this.waitForOnline) {
						this.waitForOnline.unsubscribe();
					}
					this.store.dispatch(navigateToPage({ page: this.returnTo }));
				}
			});
	
		this.getParameters = this.activatedRoute.queryParamMap.subscribe((params) => {
			this.returnTo = params.get('returnTo') || 'home';
		});

		this.backendError$ = this.store
			.select(selectBackendStateError)
			.pipe(filter((errorMessage: ErrorMessage) => errorMessage !== null));
	}



	ngOnDestroy(): void {
		if (this.waitForOnline) this.waitForOnline.unsubscribe();
		if (this.getParameters) this.getParameters.unsubscribe();
		if (this.unsub) this.unsub.unsubscribe();
	}
}
